import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import Slider from 'react-slick';
import parser from 'html-react-parser'

import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

const StorySliderBuilder = ({slider3Slides}) => {
  
  

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      {slider3Slides.map((block, index) => (
        <div key={index}>
          <div className='about-col-bx light-blue-col'>
            <div className='heading-level-3a'>{block.slider3SlideTitle}</div>
            <p>{block.slider3SlideText && parser(block.slider3SlideText)}</p>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default StorySliderBuilder;
